<template>
  <div>
    <b-card>
      <template slot="header">
        <h4 class="mt-2 custom-card-header-text">
          Site Visits <span v-if="$route.query.tag">tagged "{{ $route.query.tag | capitalize }}"</span>
        </h4>
        <ul class="list-inline float-right header_table">
          <li v-if="communities.length > 1" class="list-inline-item place-center">
            <label for="communityFilter" class="custom-card-header-filter label-bottom-0">Community:</label>
          </li>
          <li v-if="communities.length > 1" class="list-inline-item">
            <b-form-select
              v-model="selected"
              @change="filterByCommunity"
              class="custom-card-header-filter"
              id="communityFilter"
            >
              <option :value="null" selected disabled>Community</option>
              <option value="all">All</option>
              <option v-for="community in communities" :key="community._id" v-bind:value="community._id">
                {{ community.name }}
              </option>
            </b-form-select>
          </li>
          <li>
            <div class="row-bak d-flex-bak align-items-center-bak mr-2">
              <datepicker
                @changed="dateFilter"
                :value="defaultDateRange"
                :initial-range="initialDateRange"
                style="padding-right: 10px;"
                label="Date Range">
</datepicker>
            </div>
          </li>
          <template v-if="$route.query.tag">
            <li class="list-inline-item">
              <b-dropdown
                class="float-right"
                v-b-tooltip.hover.bottom
                title="Additional options"
                variant="btn btn-dropbox btn-sm tab-focus"
                right
              >
                <template slot="button-content">
                  <i class="icon-settings"></i>
                </template>
                <b-dropdown-item :to="'/engagement/requests/recent-requests-with-tag?tag=' + $route.query.tag">
                  Recent requests with tag
                </b-dropdown-item>
                <b-dropdown-item :to="'/engagement/responses/responders-matched-to-tag?tag=' + $route.query.tag">
                  Responders matched to tag
                </b-dropdown-item>
              </b-dropdown>
            </li>
          </template>
          <li class="list-inline-item">
            <button
              type="button"
              aria-label="Export"
              aria-live="assertive"
              v-if="exportBtn"
              :disabled="loadingData"
              @click="exportData"
              title="Download request data"
              class="btn custom-card-header-filter btn-dropbox tab-focus"
            >
              <i class="icon-cloud-download"></i>
            </button>
            <button
              type="button"
              v-if="processBtn"
              v-b-tooltip.hover.bottom
              title="Generating report"
              class="btn custom-card-header-filter btn-dropbox"
            >
              <i class="fa fa-spinner fa-spin"></i>
            </button>
          </li>
        </ul>
      </template>
      <b-card-body>
        <div
          v-if="loadingData"
          class="visitors-loading text-center py-5"
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <i class="fa fa-spinner fa-spin fa-2x mb-3 d-block" aria-hidden="true"></i>
          <p class="mb-0 text-muted">Loading site visit data…</p>
        </div>
        <template v-else>
        <h1 v-if="isEmpty" style="text-align: center;">No data available</h1>
        <search-section v-else search-placeholder="Search Site Visits..." @search="handleSearch" @limit-change="handleLimitChange"/>
        <v-client-table
          ref="table"
          :data="tableData"
          :columns="columns"
          :options="options"
          name="dataTable"
          id="dataTable"
        >
          <span slot="community" slot-scope="props">
            {{ props.row.community ? props.row.community : "N/A" }}
          </span>
          <template slot="no-data">
            <div class="no-data-custom">No data available.</div>
          </template>
          <span slot="member" slot-scope="props" class="display-link" @click="redirectUrls(props.row.memberId)" v-if="props.row.memberId">
            {{ props.row.member }}
          </span>
          <span slot="member" slot-scope="props" v-else-if="props.row.member">
            {{ props.row.member }}
          </span>
          <span slot="title" slot-scope="props">
            {{ props.row.title ? props.row.title : "N/A" }}
          </span>
          <span slot="date" slot-scope="props" v-if="props.row.date">
            {{ props.row.date | momentDate }}
          </span>
          <span slot="date" v-else>N/A</span>
          <span slot="status" slot-scope="props" :class="getStatusClass(props.row.status)">
            {{ props.row.status ? setStatus(props.row.status) : "N/A" }}
          </span>
          <span slot="favorite" slot-scope="props" v-if="props.row.favorite">
            <button
              type="button"
              aria-live="assertive"
              class="btn custom-card-header-filter btn-transparent btn:focus tab-focus"
              @click="favoriteRequest(props.row.requestId, 'unfavorite')"
              v-b-tooltip.hover.bottom
              title="favorite"
              aria-label="favorite"
            >
              <i class="fa fa-star gold-color" aria-label="favorite"></i>
            </button>
          </span>
          <span slot="favorite" slot-scope="props" v-else>
            <button
              type="button"
              aria-live="assertive"
              class="btn custom-card-header-filter btn-transparent btn:focus tab-focus"
              @click="favoriteRequest(props.row.requestId, 'favorite')"
              v-b-tooltip.hover.bottom
              title="unfavorite"
            >
              <i class="fa fa-star-o" aria-label="unfavorite"></i>
            </button>
          </span>
        </v-client-table>
        </template>
      </b-card-body>
    </b-card>
    <!-- Modals and other components -->
  </div>
</template>

<script>
import { shuffleArray } from "@/shared/utils";
import axios from "axios";
import { exportCSV } from "@/assets/js/common";
import { setRequestStatus } from "@/assets/js/set-status";

import VueNotifications from "vue-notifications";
import datepicker from "./components/datePicker";
import { isEmpty } from "lodash";
import SearchSection from '@/views/engagement/components/searchSection.vue';


export default {
  name: "requests",
  components: {
    datepicker,
    SearchSection
  },
  
  data() {
    return {
      storedParams: "",
      loadingData: true,
      isEmpty: null,
      tableData: [],
      communities: [],
      ask: {},
      matchedAdvisors: [],
      advisorEmail: "",
      addAdvisorErrMsg: "",
      addAdvisorModal: false,
      searchQuery: "",
      askCount: 0,
      selected: "all",
      selectedTimeframe: "monthly",
      token: "",
      columns: ["community", "date", "page", "visits"],
      options: {
        headings: {
          community: "Community",
          date: "Date",
          page: "Page",
          visits: "Visits"
        },
        sortable: ["community", "date", "page", "visits"],
        sortIcon: { base: "fa", up: "fa-sort-asc", down: "fa-sort-desc", is: "fa-sort" },
        // `date` arrives as a "MM/DD/YYYY" string, which the default sort compares
        // alphabetically (12/31/2024 landing above 12/30/2025). Compare as real dates.
        customSorting: {
          date(ascending) {
            const toTime = (value) => {
              if (!value) return 0;
              const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(String(value));
              const t = m ? new Date(+m[3], +m[1] - 1, +m[2]).getTime() : new Date(value).getTime();
              return isNaN(t) ? 0 : t;
            };
            return (a, b) => (ascending ? 1 : -1) * (toTime(a.date) - toTime(b.date));
          }
        },
        pagination: {
          chunk: 10,
          nav: "fixed",
        },
        translations: {
          noData: "No data available.",
        }
      },
      serverURL: `${process.env.VUE_APP_API_BASE_URL}/dashboard/visitors`,
      exportBtn: true,
      processBtn: false,
      showResponseModal: false,
      selectedRequestId: "",
      resAdvisorEmail: "",
      addResAdvisorErrMsg: "",
      advisorResponse: "",
      errorAdvisorResponse: "",
      addRecipientEmailErrMsg: "",
      recipientEmail: "",
      showShareRequestModal: false,
      loadingShareRequest: false,
      defaultDateRange: 'last-30',
      initialDateRange: null,
      selectedDates: {
        startDate: null,
        endDate: null,
        selectedValue: null
      },
    };
  },
  filters: {
    momentDate(value) {
      if (!value) return "";
      return value;
    },
    capitalize(value) {
      if (!value) return "";
      return value.toString().charAt(0).toUpperCase() + value.toString().slice(1);
    },
  },
  notifications: {
    showWarnMsg: {
      type: VueNotifications.types.warn,
      message: "No data found for export file",
    },
    showDownloadingMsg: {
      type: VueNotifications.types.success,
      message: "Export request sent.  Data is now downloading.",
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      message: "This request cannot be shared.",
    },
    showDataErrorMsg: {
      type: VueNotifications.types.error,
      message: "No data available.",
    },
    showSuccessMsg: {
      type: VueNotifications.types.success,
      message: "New advisor added successfully.",
    },
  },
  async created() {
    const dict = {
      custom: {
        advisorEmail: {
          required: "The email field is required.",
          email: "Please enter valid email address.",
        },
        recipientEmail: {
          required: "The email field is required.",
          email: "Please enter valid email address.",
        },
        resAdvisorEmail: {
          required: "The email field is required.",
          email: "Please enter valid email address.",
        },
        advisorResponse: {
          required: "The response field is required.",
        },

      },
    };
    this.$validator.localize("en", dict);
    this.token = localStorage.getItem("token");
    const user = localStorage.getItem("authUser");
    if (user) {
      this.authUser = JSON.parse(user);
    }
    // Apply timeframe from query params before fetching data (e.g. navigating from Dashboard widget)
    const timeframe = this.$route.query.timeframe;
    if (timeframe) {
      this.selectedTimeframe = timeframe;
      var timeframeToDateRange = { weekly: 'last-7', monthly: 'last-30', ytd: 'ytd', all: null, custom: 'custom' };
      this.defaultDateRange = timeframe in timeframeToDateRange ? timeframeToDateRange[timeframe] : 'last-30';

      // For custom timeframe, read startDate/endDate from URL and pre-populate the date filter
      if (timeframe === 'custom') {
        const startDateParam = this.$route.query.startDate;
        const endDateParam = this.$route.query.endDate;
        if (startDateParam && endDateParam) {
          this.selectedDates.startDate = new Date(startDateParam);
          this.selectedDates.endDate = new Date(endDateParam);
          this.initialDateRange = { start: new Date(startDateParam), end: new Date(endDateParam) };
        }
      }
    }
    await this.getCommunities();
  },
  methods: {
    async fetchData() {
      this.loadingData = true;
      try {
        const params = {
          community: this.selected !== 'all' ? this.selected : undefined,
          timeframe: this.selectedTimeframe,
          query: this.searchQuery,
        };

        if (this.selectedTimeframe === 'custom' && this.selectedDates.startDate && this.selectedDates.endDate) {
          params.startDate = new Date(this.selectedDates.startDate).toISOString().split('T')[0];
          params.endDate = new Date(this.selectedDates.endDate).toISOString().split('T')[0];
        }

        const response = await axios.get(this.serverURL, {
          headers: { "x-access-token": this.token },
          params,
        });

        const data = response.data.requestData || [];
        this.tableData = data;
        this.isEmpty = data.length === 0;
      } catch (error) {
        console.error("Error fetching data:", error);
        this.tableData = [];
        this.isEmpty = true;
      } finally {
        this.loadingData = false;
      }
    },
    onLoaded(data) {
      this.setActionButtonAnnouncement();
      this.$helpers.setTabindexOnTableCells();
      this.isEmpty = data.data.askCount === 0;
    },
    async getCommunities() {
      try {
        const { data } = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/dashboard/sidebar-community`,
          { headers: { "x-access-token": this.token } }
        );
        this.communities = data;
        const communityId = this.$route.params.community_id || this.$route.query.community_id || localStorage.getItem('user_modal_option');
        if (communityId && communityId !== 'all') {
          const selectedCommunity = data.filter(community => community._id == communityId);
          if (selectedCommunity.length >= 1) {
            this.selected = selectedCommunity[0]._id;
          }
        } else {
          if (this.communities.length <= 1) {
            this.selected = this.communities[0]._id;
          }
        }
        this.filterByCommunity();
      } catch (error) {
        console.error("Error fetching communities:", error);
        this.loadingData = false;
        this.communities = [];
        this.isEmpty = true;
      }
    },
      handleSearch(searchText) {
			// Use the search text from the child component to filter your table
			this.$refs.table.setFilter(searchText);
		},
		handleLimitChange(newLimit) {
			// Use the new limit value from the child to update your table
			this.$refs.table.setLimit(newLimit);
		},
    filterByCommunity() {
      this.fetchData();
    },
    dateFilter(res) {
        this.selectedDates.startDate = res.startDate;
        this.selectedDates.endDate = res.endDate;
        this.selectedDates.selectedValue = res.selectedValue;
        if(this.selectedDates.selectedValue == 'last-7') {
          this.selectedTimeframe = 'weekly';
        } else if(this.selectedDates.selectedValue == 'last-30') {
          this.selectedTimeframe = 'monthly';
        } else if(this.selectedDates.selectedValue == 'ytd') {
          this.selectedTimeframe = 'ytd';
        } else if(this.selectedDates.selectedValue == 'custom') {
          this.selectedTimeframe = 'custom';
        }else if(this.selectedDates.selectedValue == null) {
          this.selectedTimeframe = 'all';
        }
        this.fetchData();
        // this.onLoaded();
    },
    onTimeframeChange() {
      this.fetchData();
    },
    setStatus(status) {
      return setRequestStatus(status);
    },
    getStatusClass(status) {
      return {
        badge: true,
        'badge-success': setStatus(status) == 'New',
        'badge-primary': setStatus(status) == 'Active',
        'badge-warning': setStatus(status) == 'In Review' || setStatus(status) == 'Pending',
        'badge-primary-light': setStatus(status) == 'Closed',
        'badge-primary': setStatus(status) == 'Tag' || setStatus(status) == 'Matching' || setStatus(status) == 'Reviewed',
      };
    },
    async exportData() {
      if (this.tableData.length === 0) {
        this.showWarnMsg();
        this.processBtn = false;
        this.exportBtn = true;
        return;
      }

      this.showDownloadingMsg();
      this.exportBtn = false;
      this.processBtn = true;

      const desiredOrder = ['community', 'date', 'page', 'visits'];
      const headers = {
        community: 'Community',
        date: 'Date',
        page: 'Page',
        visits: 'Visits'
      };

      const rearrangedData = this.tableData.map(data => {
        let rearranged = {};
        desiredOrder.forEach(key => {
          rearranged[headers[key]] = data[key] != null ? data[key] : "";
        });
        return rearranged;
      });

      await exportCSV(rearrangedData, 'visitors', [], []);
      this.processBtn = false;
      this.exportBtn = true;
    },
  }
};
</script>

<style scoped>
.visitors-loading {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>